import axiosInstance from "../../../../axiosInstance";
import { HRMS_UTILITY_API_URL } from "../../../Constants/baseConstant";
import { toast } from "react-toastify";

export const PriceHelper = async (params) => {
    
    return await axiosInstance("/plans/getPrice", {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
          team_size: params?.team_size || "Upto 10",
        }
    })
        .then((res) => {
          return { data: res?.data };
        })
        .catch((err) => {
          err?.response?.data?.error?.[0]?.message && toast.error(err?.response?.data?.error?.[0]?.message)
          return { message: err?.response?.data };
        });
};
